var _path, _g, _path2, _g2, _path3, _g3, _ellipse, _ellipse2, _rect, _rect2, _path4, _path5, _g4, _path6, _path7, _g5, _g6, _ellipse3, _circle, _circle2, _circle3, _circle4, _path8, _path9, _g7, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnboarding1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 375,
    viewBox: "0 0 390 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_680_260",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -17,
    y: 32,
    width: 146,
    height: 146
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-17 32H129V178H-17V32Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_680_260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67212 162.632C9.14191 144.739 7.72417 131.895 6.05286 131.895C4.38154 131.895 2.9638 144.739 2.43359 162.632H9.67212Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3159 114.309C48.3159 133.693 39.7173 139.579 29.1054 139.579C18.4974 139.579 9.8949 133.693 9.8949 114.309C9.8949 94.9298 25.2633 66.5789 29.1054 66.5789C32.9475 66.5789 48.3159 94.9298 48.3159 114.309Z",
    fill: "#A6D388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2633 111.651C25.2633 133.067 16.6647 139.579 6.05281 139.579C-4.55524 139.579 -13.1577 133.067 -13.1577 111.651C-13.1577 90.2232 2.21071 58.8947 6.05281 58.8947C9.89492 58.8947 25.2633 90.2232 25.2633 111.651Z",
    fill: "#77B255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5792 97.3157L67.5266 47.3684L117.474 97.3157V158.789H17.5792V97.3157Z",
    fill: "#FFE8B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3685 158.789H67.5264V97.3157H71.3685V158.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4213 158.789H17.5792V97.3157H21.4213V158.789ZM113.632 158.789H117.474V97.3157H113.632V158.789Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.474 101.158C116.969 101.158 116.469 101.059 116.003 100.866C115.537 100.673 115.114 100.389 114.757 100.032L67.5264 52.801L20.2954 100.032C19.9387 100.389 19.5152 100.672 19.0492 100.865C18.5831 101.058 18.0836 101.157 17.5791 101.157C17.0746 101.157 16.5751 101.058 16.109 100.865C15.6429 100.672 15.2194 100.389 14.8627 100.032C14.506 99.6753 14.223 99.2518 14.03 98.7857C13.8369 98.3196 13.7375 97.8201 13.7375 97.3156C13.7375 96.8111 13.8369 96.3116 14.03 95.8455C14.223 95.3794 14.506 94.9559 14.8627 94.5992L64.8101 44.6519C65.1666 44.2948 65.59 44.0114 66.0561 43.8181C66.5222 43.6248 67.0219 43.5254 67.5264 43.5254C68.031 43.5254 68.5307 43.6248 68.9968 43.8181C69.4629 44.0114 69.8863 44.2948 70.2428 44.6519L120.19 94.5992C120.729 95.1358 121.097 95.8205 121.246 96.5663C121.395 97.3121 121.319 98.0855 121.028 98.7882C120.737 99.4909 120.244 100.091 119.611 100.513C118.978 100.935 118.234 101.159 117.474 101.158Z",
    fill: "#66757F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5266 101.158C66.766 101.159 66.022 100.935 65.3891 100.513C64.7563 100.091 64.263 99.4909 63.9719 98.7882C63.6809 98.0855 63.6052 97.3121 63.7544 96.5663C63.9037 95.8205 64.2711 95.1358 64.8102 94.5992L89.7839 69.6255C90.5043 68.9051 91.4814 68.5004 92.5002 68.5004C93.5191 68.5004 94.4962 68.9051 95.2166 69.6255C95.937 70.346 96.3418 71.3231 96.3418 72.3419C96.3418 73.3608 95.937 74.3379 95.2166 75.0583L70.2429 100.032C69.8866 100.389 69.4632 100.673 68.9971 100.866C68.5309 101.059 68.0312 101.158 67.5266 101.158Z",
    fill: "#66757F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1581 158.789H36.7897V135.737H52.1581V158.789Z",
    fill: "#C1694F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2634 151.105H86.7371V135.736H98.2634V151.105Z",
    fill: "#55ACEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8949 151.105H90.5791V135.736H82.8949V151.105ZM102.105 151.105H94.4212V135.736H102.105V151.105ZM52.1581 116.526H36.7897V101.157H52.1581V116.526ZM102.105 116.526H82.8949V101.157H102.105V116.526Z",
    fill: "#55ACEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.158 166.474C125.158 168.512 124.348 170.466 122.907 171.907C121.466 173.348 119.512 174.158 117.474 174.158H-5.47363C-7.51161 174.158 -9.46611 173.348 -10.9072 171.907C-12.3483 170.466 -13.1578 168.512 -13.1578 166.474C-13.1578 164.436 -12.3483 162.481 -10.9072 161.04C-9.46611 159.599 -7.51161 158.789 -5.47363 158.789H117.474C119.512 158.789 121.466 159.599 122.907 161.04C124.348 162.481 125.158 164.436 125.158 166.474Z",
    fill: "#5C913B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1581 174.158H36.7897V158.789H52.1581V174.158Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_680_260",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 32,
    width: 146,
    height: 146
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129 32H275V178H129V32Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_680_260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.672 162.632C155.142 144.739 153.724 131.895 152.053 131.895C150.382 131.895 148.964 144.739 148.434 162.632H155.672Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.316 114.309C194.316 133.693 185.717 139.579 175.105 139.579C164.497 139.579 155.895 133.693 155.895 114.309C155.895 94.9298 171.263 66.5789 175.105 66.5789C178.948 66.5789 194.316 94.9298 194.316 114.309Z",
    fill: "#A6D388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.263 111.651C171.263 133.067 162.665 139.579 152.053 139.579C141.445 139.579 132.842 133.067 132.842 111.651C132.842 90.2232 148.211 58.8947 152.053 58.8947C155.895 58.8947 171.263 90.2232 171.263 111.651Z",
    fill: "#77B255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.579 97.3157L213.527 47.3684L263.474 97.3157V158.789H163.579V97.3157Z",
    fill: "#FFE8B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.368 158.789H213.526V97.3157H217.368V158.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.421 158.789H163.579V97.3157H167.421V158.789ZM259.632 158.789H263.474V97.3157H259.632V158.789Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.474 101.158C262.969 101.158 262.469 101.059 262.003 100.866C261.537 100.673 261.114 100.389 260.757 100.032L213.526 52.801L166.295 100.032C165.939 100.389 165.515 100.672 165.049 100.865C164.583 101.058 164.084 101.157 163.579 101.157C163.075 101.157 162.575 101.058 162.109 100.865C161.643 100.672 161.219 100.389 160.863 100.032C160.506 99.6753 160.223 99.2518 160.03 98.7857C159.837 98.3196 159.738 97.8201 159.738 97.3156C159.738 96.8111 159.837 96.3116 160.03 95.8455C160.223 95.3794 160.506 94.9559 160.863 94.5992L210.81 44.6519C211.167 44.2948 211.59 44.0114 212.056 43.8181C212.522 43.6248 213.022 43.5254 213.526 43.5254C214.031 43.5254 214.531 43.6248 214.997 43.8181C215.463 44.0114 215.886 44.2948 216.243 44.6519L266.19 94.5992C266.729 95.1358 267.097 95.8205 267.246 96.5663C267.395 97.3121 267.319 98.0855 267.028 98.7882C266.737 99.4909 266.244 100.091 265.611 100.513C264.978 100.935 264.234 101.159 263.474 101.158Z",
    fill: "#66757F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.527 101.158C212.766 101.159 212.022 100.935 211.389 100.513C210.756 100.091 210.263 99.4909 209.972 98.7882C209.681 98.0855 209.605 97.3121 209.754 96.5663C209.904 95.8205 210.271 95.1358 210.81 94.5992L235.784 69.6255C236.504 68.9051 237.481 68.5004 238.5 68.5004C239.519 68.5004 240.496 68.9051 241.217 69.6255C241.937 70.346 242.342 71.3231 242.342 72.3419C242.342 73.3608 241.937 74.3379 241.217 75.0583L216.243 100.032C215.887 100.389 215.463 100.673 214.997 100.866C214.531 101.059 214.031 101.158 213.527 101.158Z",
    fill: "#66757F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.158 158.789H182.79V135.737H198.158V158.789Z",
    fill: "#C1694F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.263 151.105H232.737V135.736H244.263V151.105Z",
    fill: "#55ACEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.895 151.105H236.579V135.736H228.895V151.105ZM248.105 151.105H240.421V135.736H248.105V151.105ZM198.158 116.526H182.79V101.157H198.158V116.526ZM248.105 116.526H228.895V101.157H248.105V116.526Z",
    fill: "#55ACEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.158 166.474C271.158 168.512 270.348 170.466 268.907 171.907C267.466 173.348 265.512 174.158 263.474 174.158H140.526C138.488 174.158 136.534 173.348 135.093 171.907C133.652 170.466 132.842 168.512 132.842 166.474C132.842 164.436 133.652 162.481 135.093 161.04C136.534 159.599 138.488 158.789 140.526 158.789H263.474C265.512 158.789 267.466 159.599 268.907 161.04C270.348 162.481 271.158 164.436 271.158 166.474Z",
    fill: "#5C913B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.158 174.158H182.79V158.789H198.158V174.158Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_680_260",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 273,
    y: 32,
    width: 147,
    height: 146
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M273.027 32H419.027V178H273.027V32Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_680_260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.699 162.632C299.169 144.739 297.751 131.895 296.08 131.895C294.408 131.895 292.991 144.739 292.46 162.632H299.699Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.343 114.309C338.343 133.693 329.744 139.579 319.132 139.579C308.524 139.579 299.922 133.693 299.922 114.309C299.922 94.9298 315.29 66.5789 319.132 66.5789C322.974 66.5789 338.343 94.9298 338.343 114.309Z",
    fill: "#A6D388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.29 111.651C315.29 133.067 306.692 139.579 296.08 139.579C285.472 139.579 276.869 133.067 276.869 111.651C276.869 90.2232 292.238 58.8947 296.08 58.8947C299.922 58.8947 315.29 90.2232 315.29 111.651Z",
    fill: "#77B255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.606 97.3157L357.553 47.3684L407.501 97.3157V158.789H307.606V97.3157Z",
    fill: "#FFE8B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.395 158.789H357.553V97.3157H361.395V158.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.448 158.789H307.606V97.3157H311.448V158.789ZM403.659 158.789H407.501V97.3157H403.659V158.789Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.501 101.158C406.996 101.158 406.496 101.059 406.03 100.866C405.564 100.673 405.141 100.389 404.784 100.032L357.553 52.801L310.322 100.032C309.966 100.389 309.542 100.672 309.076 100.865C308.61 101.058 308.11 101.157 307.606 101.157C307.101 101.157 306.602 101.058 306.136 100.865C305.67 100.672 305.246 100.389 304.89 100.032C304.533 99.6753 304.25 99.2518 304.057 98.7857C303.864 98.3196 303.764 97.8201 303.764 97.3156C303.764 96.8111 303.864 96.3116 304.057 95.8455C304.25 95.3794 304.533 94.9559 304.89 94.5992L354.837 44.6519C355.193 44.2948 355.617 44.0114 356.083 43.8181C356.549 43.6248 357.049 43.5254 357.553 43.5254C358.058 43.5254 358.557 43.6248 359.024 43.8181C359.49 44.0114 359.913 44.2948 360.27 44.6519L410.217 94.5992C410.756 95.1358 411.123 95.8205 411.273 96.5663C411.422 97.3121 411.346 98.0855 411.055 98.7882C410.764 99.4909 410.271 100.091 409.638 100.513C409.005 100.935 408.261 101.159 407.501 101.158Z",
    fill: "#66757F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.553 101.158C356.793 101.159 356.049 100.935 355.416 100.513C354.783 100.091 354.29 99.4909 353.999 98.7882C353.708 98.0855 353.632 97.3121 353.781 96.5663C353.931 95.8205 354.298 95.1358 354.837 94.5992L379.811 69.6255C380.531 68.9051 381.508 68.5004 382.527 68.5004C383.546 68.5004 384.523 68.9051 385.243 69.6255C385.964 70.346 386.369 71.3231 386.369 72.3419C386.369 73.3608 385.964 74.3379 385.243 75.0583L360.27 100.032C359.913 100.389 359.49 100.673 359.024 100.866C358.558 101.059 358.058 101.158 357.553 101.158Z",
    fill: "#66757F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.185 158.789H326.816V135.737H342.185V158.789Z",
    fill: "#C1694F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.29 151.105H376.764V135.736H388.29V151.105Z",
    fill: "#55ACEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.922 151.105H380.606V135.736H372.922V151.105ZM392.132 151.105H384.448V135.736H392.132V151.105ZM342.185 116.526H326.816V101.157H342.185V116.526ZM392.132 116.526H372.922V101.157H392.132V116.526Z",
    fill: "#55ACEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.185 166.474C415.185 168.512 414.375 170.466 412.934 171.907C411.493 173.348 409.539 174.158 407.501 174.158H284.553C282.515 174.158 280.561 173.348 279.12 171.907C277.679 170.466 276.869 168.512 276.869 166.474C276.869 164.436 277.679 162.481 279.12 161.04C280.561 159.599 282.515 158.789 284.553 158.789H407.501C409.539 158.789 411.493 159.599 412.934 161.04C414.375 162.481 415.185 164.436 415.185 166.474Z",
    fill: "#5C913B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.185 174.158H326.816V158.789H342.185V174.158Z",
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.9305,
    cy: 27.801,
    rx: 76.9305,
    ry: 27.801,
    transform: "matrix(0.984123 -0.177488 0.209274 0.977857 122 285.707)",
    fill: "#F2EFE7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.9305,
    cy: 27.801,
    rx: 76.9305,
    ry: 27.801,
    transform: "matrix(0.984123 -0.177488 0.209274 0.977857 199.961 300.609)",
    fill: "#F2EFE7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 206.708,
    y: 215.811,
    width: 18.2143,
    height: 58.1115,
    rx: 9.10714,
    transform: "rotate(63.2891 206.708 215.811)",
    fill: "#FFD36A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 331.691,
    y: 267.57,
    width: 18.2143,
    height: 58.1115,
    rx: 9.10714,
    transform: "rotate(145.994 331.691 267.57)",
    fill: "#FFD36A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M244.116 294.06C244.205 294.06 244.276 294.121 244.365 294.152V268.992L219.174 274.593C219.174 274.593 219.441 285.153 219.761 294.182C219.85 294.182 219.939 294.091 220.046 294.091H244.116V294.06Z",
    fill: "#FFD36A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M219.694 297.059C219.802 298.37 219.893 299.354 219.983 299.778C220.183 301.263 219.404 301.649 218.572 301.34C215.332 299.72 212.435 299.875 209.811 301.34C206.082 303.731 205.449 310.847 208.598 313.721C210.39 315.533 212.309 316.401 214.282 316.575H239.261C242.718 316.44 244.275 314.222 244.365 310.442V296.982C244.365 296.982 244.202 297.04 244.112 297.04H219.694V297.059Z",
    fill: "#A6E7BC"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_680_260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.05 292.848C245.05 292.848 244.886 292.784 244.795 292.784H220.161C220.052 292.784 219.979 292.848 219.87 292.848C218.704 293.02 217.775 294.156 217.775 295.572C217.775 297.116 218.831 298.382 220.161 298.382H244.795C244.886 298.382 244.959 298.339 245.05 298.317C246.235 298.167 247.164 297.009 247.164 295.572C247.164 294.135 246.235 292.998 245.05 292.827V292.848Z",
    fill: "#A6E7BC"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.41 294.034C254.321 294.034 254.25 294.109 254.161 294.146V263.395L279.352 270.241C279.352 270.241 279.085 283.147 278.764 294.183C278.675 294.183 278.586 294.071 278.48 294.071H254.41V294.034Z",
    fill: "#FFD36A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M278.832 297.059C278.724 298.37 278.633 299.354 278.543 299.778C278.344 301.263 279.122 301.649 279.955 301.34C283.195 299.72 286.091 299.875 288.715 301.34C292.444 303.731 293.078 310.847 289.928 313.721C288.136 315.533 286.218 316.401 284.245 316.575H259.266C255.808 316.44 254.252 314.222 254.161 310.442V296.982C254.161 296.982 254.324 297.04 254.415 297.04H278.832V297.059Z",
    fill: "#A6E7BC"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_680_260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.476 292.848C253.476 292.848 253.64 292.784 253.731 292.784H278.365C278.474 292.784 278.547 292.848 278.656 292.848C279.822 293.02 280.752 294.156 280.752 295.572C280.752 297.116 279.695 298.382 278.365 298.382H253.731C253.64 298.382 253.567 298.339 253.476 298.317C252.292 298.167 251.362 297.009 251.362 295.572C251.362 294.135 252.292 292.998 253.476 292.827V292.848Z",
    fill: "#A6E7BC"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_680_260)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.781 170.196C234.953 162.629 243.588 164.806 246.984 171.599C247.782 173.195 250.336 175.429 254.167 171.599C257.359 167.608 270.927 159.627 287.686 181.176L287.543 180.944C297.937 194.456 303.546 214.233 305.806 243.534C307.743 268.705 307.337 271.904 301.301 279.001C292.725 289.085 283.688 288.895 274.791 278.433L267.675 270.066L262.309 278.433C255.736 288.678 243.741 289.276 235.649 279.761C229.749 272.824 229.587 272.824 224.246 279.761C217.115 289.027 205.81 288.693 197.543 278.972C191.59 271.973 191.082 268.419 192.726 245.354C195.013 213.272 207.397 182.173 222.599 170.336C222.659 170.289 222.72 170.243 222.781 170.196Z",
    fill: "#FFD36A"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.864,
    cy: 231.905,
    rx: 35.687,
    ry: 34.2875,
    fill: "url(#paint0_radial_680_260)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 237.231,
    cy: 216.43,
    r: 5.46429,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.910714,
    cy: 0.910714,
    r: 0.910714,
    transform: "matrix(-1 0 0 1 240.874 214.609)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.266,
    cy: 216.43,
    r: 5.46429,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.910714,
    cy: 0.910714,
    r: 0.910714,
    transform: "matrix(-1 0 0 1 260.909 214.609)",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.798 206.94C234.16 207.17 233.753 207.45 233.579 207.7C233.422 207.927 233.11 207.983 232.883 207.825C232.657 207.667 232.601 207.356 232.758 207.129C233.109 206.624 233.752 206.254 234.459 205.999C235.184 205.738 236.054 205.572 236.949 205.527C238.709 205.439 240.728 205.817 241.927 207.069C242.118 207.268 242.111 207.585 241.912 207.776C241.712 207.967 241.396 207.96 241.205 207.76C240.305 206.82 238.65 206.443 236.999 206.526C236.188 206.567 235.418 206.717 234.798 206.94Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.576 206.929C255.063 207.15 254.736 207.42 254.594 207.665C254.455 207.904 254.149 207.986 253.91 207.847C253.672 207.709 253.59 207.403 253.729 207.164C254.024 206.655 254.572 206.273 255.179 206.011C255.799 205.743 256.54 205.573 257.302 205.528C258.803 205.437 260.531 205.826 261.549 207.103C261.722 207.318 261.686 207.633 261.471 207.805C261.255 207.978 260.94 207.942 260.768 207.726C260.037 206.811 258.703 206.445 257.362 206.526C256.703 206.565 256.077 206.712 255.576 206.929Z",
    fill: "black"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_680_260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.122 229.768C254.201 223.595 241.272 223.146 236.011 229.768C235.282 230.862 235.075 232.162 235.1 233.547C235.44 236.147 237.992 237.374 240.252 237.326C241.746 237.35 242.427 236.864 243.216 236.317V233.802C243.216 230.971 251.369 230.667 251.369 233.802V236.123C252.645 236.755 253.909 237.374 255.476 237.326C257.651 237.35 259.705 236.098 260.166 233.899C260.3 232.696 260.215 230.971 259.134 229.78L259.122 229.768Z",
    fill: "#020304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.205 233.802V236.317C244.031 235.746 244.979 235.102 247.105 234.92C248.745 234.847 250.057 235.491 251.345 236.123V233.802C251.345 230.667 243.192 230.971 243.192 233.802H243.205Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M300.343 169.721L295.588 180.206L306.798 179.214C309.238 179.099 311.528 177.663 312.604 175.289C314.136 171.911 312.632 167.928 309.246 166.391C305.86 164.852 301.873 166.345 300.343 169.721ZM315.175 180.086L308.675 181.585L313.111 186.393C314.03 187.474 315.502 188.025 316.972 187.685C317.47 187.57 317.941 187.358 318.356 187.061C318.772 186.763 319.124 186.386 319.393 185.952C319.662 185.517 319.843 185.033 319.924 184.529C320.005 184.024 319.985 183.508 319.866 183.011C319.369 180.913 317.27 179.602 315.175 180.086Z",
    fill: "#8ABDE6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.401 168.693C305.645 168.771 305.024 169.138 304.697 169.438C304.494 169.625 304.178 169.612 303.991 169.409C303.804 169.206 303.817 168.89 304.02 168.703C304.48 168.279 305.297 167.801 306.298 167.698C307.323 167.593 308.504 167.884 309.639 168.947C309.841 169.136 309.851 169.452 309.663 169.654C309.474 169.855 309.158 169.866 308.956 169.677C308.028 168.809 307.133 168.618 306.401 168.693Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.2 182.584C317.571 182.888 317.771 183.3 317.837 183.566C317.904 183.834 318.175 183.997 318.443 183.931C318.711 183.864 318.874 183.593 318.808 183.325C318.698 182.882 318.396 182.271 317.834 181.811C317.253 181.335 316.424 181.046 315.332 181.232C315.06 181.278 314.877 181.536 314.923 181.809C314.97 182.081 315.228 182.264 315.5 182.217C316.312 182.079 316.847 182.296 317.2 182.584Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M180.421 202.125L194.452 199.526L185.495 188.831C183.648 186.431 180.564 185.122 177.387 185.711C172.867 186.547 169.883 190.902 170.722 195.434C171.558 199.967 175.902 202.963 180.421 202.125Z",
    fill: "#8ABDE6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.003 197.794C178.059 198.404 179.209 198.512 179.925 198.428C180.199 198.396 180.448 198.592 180.48 198.866C180.512 199.14 180.316 199.389 180.042 199.421C179.145 199.527 177.772 199.393 176.503 198.66C175.213 197.914 174.065 196.567 173.628 194.319C173.576 194.048 173.753 193.786 174.024 193.733C174.295 193.681 174.557 193.858 174.61 194.129C174.992 196.097 175.969 197.196 177.003 197.794Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_680_260",
    x: 211.775,
    y: 286.784,
    width: 49.3893,
    height: 25.598,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_680_260"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_680_260",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_680_260",
    x: 245.362,
    y: 286.784,
    width: 49.3893,
    height: 25.598,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_680_260"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_680_260",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_680_260",
    x: 181.916,
    y: 159.43,
    width: 134.925,
    height: 141.095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_680_260"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_680_260",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_680_260",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(247.864 231.905) rotate(90) scale(34.2875 35.687)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2FFB1",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#DFF3BE",
    stopOpacity: 0.545833
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_680_260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.1031,
    height: 12.3572,
    fill: "white",
    transform: "translate(235.1 224.968)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding1);
export default __webpack_public_path__ + "static/media/onboarding1.4bdd965b2b5df13dab3dfbd07999dcbd.svg";
export { ForwardRef as ReactComponent };